import type { ReactNode } from 'react';

import { log } from 'src/app/utils/logging';
import { useDraftJobQuery } from 'src/graphql/generated';

import { useDraftId } from '../../hooks/useDraftId';

interface ProviderProps {
  children: ReactNode;
}

export const DraftLoader = ({ children }: ProviderProps) => {
  const draftId = useDraftId();
  const { data, error } = useDraftJobQuery({
    variables: {
      id: draftId!,
    },
    skip: !draftId,
    fetchPolicy: 'cache-and-network',
  });

  if (error) {
    log.error('DraftLoader', {
      error,
    });
  }

  if (!data) {
    return null;
  }

  return <>{children}</>;
};
